import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useWorkoutExecutionHttp } from '@/core/api/workout-executions'
import { WorkoutExecution, WorkoutExecutionPayload } from '@/core/models/workout-execution'

export type WorkoutExecutionCollection = {
    data: Array<WorkoutExecution>,
    meta?: MetaPayload,
    links?: any
}

const state: WorkoutExecutionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const workoutExecutionCollection: Module<WorkoutExecutionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: WorkoutExecutionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: WorkoutExecutionPayload) => {
                state.data.push(new WorkoutExecution(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useWorkoutExecutionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: WorkoutExecutionCollection): WorkoutExecutionCollection => {
            return state
        }
    }
}